
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {getFilterDomainList} from "@/http/services/http-services-filter";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export class LayerInfoFilterSettingsTextComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const value = formAttribute.DefaultValue
        const template = document.createElement('template');
        template.innerHTML = `<input value="` + value + `" placeholder="` + formAttribute.Placeholder + `" type="text" class="form-control">`;

        updateFilterBadge(this, value)

        initWebComponent(this, template)

        this.addEventListener('keyup', (element) => {
            const value = element.target.value
            updateFilterBadge(this, value)
        })
    }
}
